import * as React from 'react'
import Icon from '@ant-design/icons/lib/components/Icon'
import { Button, Spin } from 'antd'
import styled from 'styled-components'
import { FormattedMessage } from 'react-intl'
import { WalletOutlined } from '@ant-design/icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPaypal } from '@fortawesome/free-brands-svg-icons'
import {
  PaymeeIcon,
  SobflousIcon,
  VisaIcon,
  MastercardIcon,
} from './paymentLogos'
import { useCurrentInvoice } from './queries'
import { SelectExchangeRate } from './SelectExchangeRate'

const SelectContent = styled.div`
  & .ant-spin-container {
    height: 100%;
    display: flex;
    flex-direction: column;
  }
  & button {
    margin-bottom: ${props => props.theme.paddingUnit * 2}px;
    margin-top: ${props => props.theme.paddingUnit * 2}px;
    font-size: 21px;
    height: 48px;
    & .anticon {
      position: absolute;
      left: ${props => props.theme.paddingUnit * 3}px;
      top: 13.5px;
    }
  }
`

const Payment = ({ next }: { next: () => void }) => {
  const { isLoading: invoiceIsLoading } = useCurrentInvoice()

  return (
    <SelectContent>
      <Spin spinning={invoiceIsLoading}>
        <FormattedMessage id="selectPaymentMethod" />
        <SelectExchangeRate
          icon={
            <>
              <VisaIcon style={{ left: '56px' }} />
              <MastercardIcon />
            </>
          }
          provider="MPGS"
        >
          <FormattedMessage id="bankCard" />
        </SelectExchangeRate>
        <SelectExchangeRate
          icon={
            <span className="anti^con">
              <FontAwesomeIcon icon={faPaypal} />
            </span>
          }
          provider="PAYPAL"
        >
          <FormattedMessage id="paypal" />
        </SelectExchangeRate>
        <SelectExchangeRate
          icon={<Icon component={() => <SobflousIcon />} />}
          provider="SOBFLOUS"
        >
          <FormattedMessage id="sobflous" />
        </SelectExchangeRate>
        <SelectExchangeRate
          icon={<Icon component={() => <PaymeeIcon />} />}
          provider="PAYMEE"
        >
          <FormattedMessage id="paymee" />
        </SelectExchangeRate>
        <Button icon={<WalletOutlined />} onClick={next} type="primary">
          <FormattedMessage id="wallet" />
        </Button>
      </Spin>
    </SelectContent>
  )
}

export default Payment
